import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '@/App';
import { Button } from '@/components/ui/button';
import { ShoppingCart, User, Package, LogOut, Menu, X } from 'lucide-react';
import AuthModal from './AuthModal';

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleDownloadSpec = () => {
    window.open('https://customer-assets.emergentagent.com/job_b2b-packaging-1/artifacts/8kw17atq_POS%20Cups%20-%20Spec%20Sheet%20%281%29.pdf', '_blank');
  };

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 bg-white shadow-md z-50" data-testid="navbar">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-3" data-testid="logo-link">
              <div className="bg-blue-600 text-white p-2 rounded-lg">
                <Package className="h-8 w-8" />
              </div>
              <div>
                <div className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk' }}>
                  DC PAC LLC
                </div>
                <div className="text-xs text-gray-600 font-semibold">Value. Built In.</div>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-6">
              <button 
                onClick={handleDownloadSpec}
                className="text-gray-700 hover:text-blue-600 font-semibold transition-colors"
                data-testid="nav-spec-link"
              >
                Download Spec Sheet
              </button>
              <button 
                onClick={() => scrollToSection('products-section')}
                className="text-gray-700 hover:text-blue-600 font-semibold transition-colors"
                data-testid="nav-products-link"
              >
                Products
              </button>
              <button 
                onClick={() => scrollToSection('quote-section')}
                className="text-gray-700 hover:text-blue-600 font-semibold transition-colors"
                data-testid="nav-quote-link"
              >
                Request a Quote
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-gray-700"
              data-testid="mobile-menu-btn"
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200" data-testid="mobile-menu">
            <div className="px-4 py-4 space-y-3">
              <button 
                onClick={() => {
                  handleDownloadSpec();
                  setMobileMenuOpen(false);
                }}
                className="block w-full text-left py-2 text-gray-700 hover:text-blue-600 font-semibold"
              >
                Download Spec Sheet
              </button>
              <button 
                onClick={() => {
                  scrollToSection('products-section');
                  setMobileMenuOpen(false);
                }}
                className="block w-full text-left py-2 text-gray-700 hover:text-blue-600 font-semibold"
              >
                Products
              </button>
              <button 
                onClick={() => {
                  scrollToSection('quote-section');
                  setMobileMenuOpen(false);
                }}
                className="block w-full text-left py-2 text-gray-700 hover:text-blue-600 font-semibold"
              >
                Request a Quote
              </button>
            </div>
          </div>
        )}
      </nav>

      {showAuthModal && (
        <AuthModal 
          isOpen={showAuthModal} 
          onClose={() => setShowAuthModal(false)} 
        />
      )}
    </>
  );
};

export default Navbar;